import ApplicationsAccordion from 'components/ApplicationsAccordion';
import DetailsViewCardHeader from 'components/DetailsViewCardHeader';
import DetailsViewEntityLink from 'components/DetailsViewEntityLink';
import DetailsViewEntityMenu from 'components/DetailsViewEntityMenu';
import DetailsViewPageContainer from 'components/DetailsViewPageContainer';
import LinkedEntitiesAccordion from 'components/LinkedEntitiesAccordion';
import UpdateFarmForm from 'components/forms/UpdateFarmForm';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import {
    CARD_HEADER_DETAIL_TYPE,
    CLIENT_DETAILS_PAGE_ROUTE,
    DETAIL_TYPE_CLIENT,
    DETAIL_TYPE_FIELD,
    TEST_ID
} from './constants';
import type { FunctionComponent, Props } from './types';

const FarmDetailsPage: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const {
        applications,
        currentFarm,
        dropdownMenuItems,
        fieldMenuItems,
        handleClose,
        handleEditClose,
        handleFieldNext,
        handleSelectApplication,
        handleToggleApplications,
        handleToggleLinkedEntities,
        isApplicationsLoading,
        isApplicationsOpen,
        isClosing,
        isEditing,
        isFieldsLoading,
        isLinkedEntitiesOpen,
        isLoading,
        selectedApplicationId,
        selectedBoundaryGeometry,
        setIsClosing,
        totalFieldsCount
    } = useData();

    const { APPLICATIONS, LINKED_ENTITIES } = useTranslation();

    return (
        <DetailsViewPageContainer
            geometry={selectedBoundaryGeometry}
            handleClose={handleClose}
            testId={testId}>
            <DetailsViewCardHeader
                detailType={CARD_HEADER_DETAIL_TYPE}
                isDisabled={isEditing}
                isLoading={isLoading}
                items={dropdownMenuItems}
                name={currentFarm?.name ?? ''}
            />

            {isEditing ? (
                <UpdateFarmForm
                    formValues={currentFarm}
                    isClosing={isClosing}
                    onClose={handleEditClose}
                    setIsClosing={() => setIsClosing(false)}
                />
            ) : (
                <>
                    <LinkedEntitiesAccordion
                        isOpen={isLinkedEntitiesOpen}
                        label={LINKED_ENTITIES}
                        onToggle={handleToggleLinkedEntities}>
                        <DetailsViewEntityLink
                            entityName={currentFarm?.clientName ?? ''}
                            entityRoute={`${CLIENT_DETAILS_PAGE_ROUTE}/${currentFarm?.clientId ?? ''}`}
                            entityType={DETAIL_TYPE_CLIENT}
                        />

                        <DetailsViewEntityMenu
                            entityType={DETAIL_TYPE_FIELD}
                            isLoading={isFieldsLoading}
                            items={fieldMenuItems}
                            onNext={handleFieldNext}
                            totalCount={totalFieldsCount}
                        />
                    </LinkedEntitiesAccordion>

                    <ApplicationsAccordion
                        applications={applications}
                        isLoading={isApplicationsLoading}
                        isOpen={isApplicationsOpen}
                        label={APPLICATIONS}
                        onSelectApplication={handleSelectApplication}
                        onToggle={handleToggleApplications}
                        selectedApplicationId={selectedApplicationId}
                    />
                </>
            )}
        </DetailsViewPageContainer>
    );
};

export default FarmDetailsPage;
